import React from 'react';
import classNames from 'classnames';

import css from './IconCard.module.css';

const BRAND_AMEX = 'amex';
const BRAND_DINERS = 'diners';
const BRAND_DISCOVERY = 'discovery';
const BRAND_JCB = 'jcb';
const BRAND_MASTERCARD = 'mastercard';
const BRAND_UNIONPAY = 'unionpay';
const BRAND_VISA = 'visa';
const GLOBE = 'globe';
const DROPDOWNARROW = 'dropdownarrow';
const RIGHT_ARROW = 'rightArrow';
const BLANK_FAV = 'blankFav';
const FAV_HEART = 'favHeart';
const ACC_PLUS = 'AccPlus';
const ACC_CLOSE = 'AccClose';
const PAPER_PLAIN = 'paperPlain';
const CHEVRON_DOWN = 'chevronDown';
const ARROW_LINE_ARROW = 'arrowLineArrow';
const CART = 'cart';
const LOCATION = 'location';
const CONTACT = 'contact';
const FLAG_EN = 'flagEn';
const FLAG_NL = 'flagNl';
const UPLOAD_PHOTO = 'uploadPhoto';
const WHITE_VINYLE = 'whiteVinyle';
const MAIL = 'mail';
const FACEBOOK = 'facebook';
const INSTAGRAM = 'instagram';
const PINTEREST = 'pinterest';
const TIKTOK = 'tiktok';
const CLOSE = 'close'
const STAR = 'star';
const SHARE = 'share'
const BACK = 'back'

/**
 * Payment card icon.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @param {'amex' | 'diners' | 'discovery' | 'jcb' | 'mastercard' | 'unionpay' | 'visa'} props.brand payment card provider
 * @returns {JSX.Element} SVG icon
 */
const IconCard = props => {
  const { className, rootClassName, brand = 'default' } = props;
  const classes = classNames(rootClassName || css.root, className);
  const roleInfo = {
    role: 'img',
    ['aria-label']: brand,
  };

  switch (brand) {
    case UPLOAD_PHOTO: return (
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill="none" d="M3 5.25V3.75C3 3.35218 3.15804 2.97065 3.43934 2.68934C3.72064 2.40804 4.10218 2.25 4.5 2.25H13.5C13.8978 2.25 14.2794 2.40804 14.5607 2.68934C14.842 2.97065 15 3.35218 15 3.75V5.25M5.25 9.75L9 6M9 6L12.75 9.75M9 6V15" stroke="#28282B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    )

    case FACEBOOK:
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M10.0638 6.07165C10.0638 6.22547 10.0638 6.72681 10.0638 7.43906H12.1825L11.9528 9.62205H10.0638C10.0638 12.9886 10.0638 17.5 10.0638 17.5H7.55649C7.55649 17.5 7.55649 13.0483 7.55649 9.62205H6.25V7.43906H7.55649C7.55649 6.57335 7.55649 5.95776 7.55649 5.78636C7.55649 4.96972 7.50326 4.58225 7.80347 3.94943C8.10384 3.31664 8.95108 2.48022 10.4164 2.50036C11.8822 2.52123 12.5 2.6842 12.5 2.6842L12.1825 5.01073C12.1825 5.01073 11.2466 4.72509 10.7872 4.82689C10.3284 4.92872 10.0638 5.25537 10.0638 6.07165Z"
            fill="white"
          />
        </svg>
      );
    case CLOSE: return (
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15 5L5 15" stroke="white" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M5 5L15 15" stroke="white" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    )
    case INSTAGRAM:
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <g clipPath="url(#clip0_1230_3429)">
            <path
              d="M14.6664 -0.625H6.58338C5.00349 -0.623796 3.48865 0.00431818 2.3715 1.12142C1.25435 2.23852 0.626204 3.75329 0.625 5.33311V13.4157C0.625963 14.9957 1.254 16.5107 2.37118 17.628C3.48836 18.7453 5.00333 19.3736 6.58338 19.3748H14.6664C16.2464 19.3733 17.7612 18.745 18.8783 17.6278C19.9954 16.5105 20.6236 14.9956 20.6248 13.4157V5.33311C20.624 3.75314 19.996 2.23809 18.8788 1.12089C17.7615 0.00368255 16.2464 -0.624277 14.6664 -0.625ZM18.6138 13.4157C18.6135 14.4625 18.1976 15.4664 17.4573 16.2066C16.7171 16.9468 15.7132 17.3627 14.6664 17.363H6.58338C6.06504 17.363 5.55178 17.2609 5.07291 17.0625C4.59404 16.8641 4.15894 16.5733 3.79247 16.2068C3.42599 15.8402 3.13531 15.4051 2.93703 14.9262C2.73876 14.4473 2.63677 13.9341 2.63689 13.4157V5.33311C2.63677 4.81484 2.73876 4.30162 2.93705 3.82278C3.13534 3.34394 3.42603 2.90885 3.79252 2.54238C4.15901 2.1759 4.59412 1.88522 5.07298 1.68695C5.55185 1.48867 6.06509 1.38667 6.58338 1.38679H14.6664C15.713 1.38703 16.7166 1.80288 17.4567 2.54291C18.1968 3.28293 18.6126 4.28656 18.6129 5.33311L18.6138 13.4157Z"
              fill="white"
            />
            <path
              d="M10.6438 4.29544C7.87497 4.29544 5.625 6.55569 5.625 9.33515C5.625 12.1146 7.87585 14.3749 10.6438 14.3749C13.4117 14.3749 15.6625 12.1146 15.6625 9.33515C15.6625 6.55569 13.4126 4.29544 10.6438 4.29544ZM10.6438 12.4141C9.83057 12.4142 9.05064 12.0899 8.47555 11.5126C7.90045 10.9353 7.5773 10.1522 7.57718 9.33559C7.57707 8.51901 7.89999 7.73582 8.47492 7.15833C9.04985 6.58083 9.82969 6.25633 10.6429 6.25621C11.4561 6.2561 12.236 6.58037 12.8111 7.1577C13.3862 7.73503 13.7093 8.51812 13.7095 9.33471C13.7096 10.1513 13.3867 10.9345 12.8117 11.512C12.2368 12.0895 11.457 12.414 10.6438 12.4141ZM15.6731 3.125C15.9109 3.12518 16.1433 3.19613 16.3409 3.3289C16.5386 3.46166 16.6926 3.65028 16.7835 3.87091C16.8744 4.09155 16.8981 4.33429 16.8517 4.56847C16.8053 4.80265 16.6908 5.01775 16.5226 5.18659C16.3545 5.35543 16.1403 5.47043 15.9071 5.51706C15.6739 5.56368 15.4321 5.53984 15.2124 5.44855C14.9927 5.35725 14.8049 5.2026 14.6726 5.00414C14.5404 4.80568 14.4698 4.57231 14.4696 4.33354C14.4696 3.66725 14.9196 3.125 15.6731 3.125Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_1230_3429">
              <rect width="20" height="20" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case SHARE: return (
      <svg width="15" height="17" viewBox="0 0 15 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.5066 0.100403C13.006 0.100403 14.2254 1.31983 14.2254 2.81915C14.2252 4.31831 13.0058 5.5379 11.5066 5.5379C10.7406 5.53781 10.0498 5.21693 9.55547 4.70587L5.37773 7.29376C5.48134 7.58488 5.53803 7.89059 5.53789 8.20001L5.52617 8.45197C5.50537 8.67512 5.45294 8.8937 5.37773 9.10529L9.55547 11.6932C10.0498 11.1824 10.7409 10.8622 11.5066 10.8621C13.0058 10.8621 14.2252 12.0817 14.2254 13.5809C14.2254 15.08 13.006 16.2996 11.5066 16.2996C10.0075 16.2994 8.78789 15.08 8.78789 13.5809C8.78787 13.2716 8.84356 12.9657 8.94707 12.6746L4.76933 10.0867C4.27496 10.5977 3.58494 10.9187 2.81914 10.9188C1.31982 10.9188 0.100396 9.69929 0.100388 8.20001C0.100388 6.70082 1.31982 5.48126 2.81914 5.48126C3.58474 5.48133 4.27498 5.80173 4.76933 6.31232L8.94609 3.72443C8.84286 3.43375 8.78786 3.12804 8.78789 2.81915C8.78789 1.31995 10.0075 0.100586 11.5066 0.100403ZM11.5066 12.0174C10.6446 12.0176 9.94329 12.7188 9.94316 13.5809C9.94316 14.443 10.6445 15.1451 11.5066 15.1453C12.3689 15.1453 13.0711 14.4431 13.0711 13.5809C13.071 12.7187 12.3688 12.0174 11.5066 12.0174ZM2.81914 6.63654C1.95674 6.63654 1.25468 7.33778 1.25468 8.20001C1.25469 9.06224 1.95674 9.76349 2.81914 9.76349C3.68125 9.76336 4.38261 9.06217 4.38261 8.20001C4.38261 7.33784 3.68129 6.63667 2.81914 6.63654ZM11.5066 1.2547C10.6446 1.25488 9.94316 1.957 9.94316 2.81915C9.94329 3.68117 10.6446 4.38245 11.5066 4.38263C12.3688 4.38263 13.071 3.68131 13.0711 2.81915C13.0711 1.95688 12.3689 1.2547 11.5066 1.2547Z" fill="#3F1113" stroke="#3F1113" strokeWidth="0.2" />
      </svg>
    )
    case PINTEREST:
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M9.84708 1.25C5.0499 1.25073 2.5 4.32417 2.5 7.67542C2.5 9.22927 3.36844 11.1681 4.75896 11.7828C5.15563 11.9615 5.10313 11.7434 5.44438 10.4382C5.47135 10.3296 5.4575 10.2355 5.37 10.1342C3.38229 7.8351 4.98208 3.10865 9.56344 3.10865C16.1938 3.10865 14.9549 12.283 10.717 12.283C9.62469 12.283 8.81094 11.4255 9.06833 10.3646C9.38042 9.10094 9.99146 7.7425 9.99146 6.83177C9.99146 4.53635 6.57167 4.87688 6.57167 7.91823C6.57167 8.85813 6.90417 9.4925 6.90417 9.4925C6.90417 9.4925 5.80385 13.9375 5.59969 14.768C5.25406 16.1739 5.64635 18.4496 5.68063 18.6457C5.70177 18.7536 5.82281 18.7879 5.89063 18.699C5.99927 18.5568 7.32927 16.6595 7.70188 15.2879C7.8375 14.7884 8.39386 12.7614 8.39386 12.7614C8.76063 13.4234 9.81792 13.9776 10.9445 13.9776C14.2957 13.9776 16.718 11.0318 16.718 7.37646C16.7064 3.87208 13.7073 1.25 9.84708 1.25Z"
            fill="white"
          />
        </svg>
      );
    case TIKTOK:
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M17.8432 5.625C16.8444 5.625 15.923 5.29414 15.183 4.73599C14.3343 4.09614 13.7245 3.15757 13.5092 2.07578C13.4559 1.8085 13.4272 1.53267 13.4244 1.25H10.5714V9.0457L10.568 13.3158C10.568 14.4574 9.82462 15.4253 8.7941 15.7658C8.49503 15.8645 8.17203 15.9114 7.8357 15.8929C7.4064 15.8693 7.00411 15.7398 6.65445 15.5306C5.91036 15.0856 5.40586 14.2783 5.39219 13.3547C5.37066 11.9113 6.53755 10.7345 7.97994 10.7345C8.26465 10.7345 8.53809 10.781 8.7941 10.8654V8.73467V7.9687C8.52408 7.92871 8.24927 7.90786 7.97139 7.90786C6.39263 7.90786 4.91607 8.56411 3.8606 9.74639C3.06285 10.6398 2.58433 11.7797 2.5105 12.975C2.41377 14.5452 2.98834 16.0378 4.10259 17.1391C4.26631 17.3008 4.43824 17.4508 4.61802 17.5893C5.57334 18.3245 6.74127 18.723 7.97139 18.723C8.24927 18.723 8.52408 18.7025 8.7941 18.6625C9.94322 18.4923 11.0035 17.9663 11.8402 17.1391C12.8683 16.1229 13.4364 14.7739 13.4425 13.338L13.4278 6.96143C13.9183 7.3398 14.4546 7.65288 15.0302 7.8959C15.9253 8.27358 16.8745 8.46499 17.8514 8.46465V6.39302V5.62432C17.8521 5.625 17.8439 5.625 17.8432 5.625Z"
            fill="white"
          />
        </svg>
      );
    case STAR: return (
      <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14.0621 5.63513L10.9476 8.67113L11.6831 12.9591C11.6988 13.0511 11.6886 13.1456 11.6534 13.232C11.6182 13.3184 11.5596 13.3933 11.4841 13.4481C11.4086 13.5029 11.3193 13.5355 11.2263 13.5423C11.1332 13.549 11.0402 13.5295 10.9576 13.4861L7.10658 11.4616L3.25608 13.4856C3.17351 13.529 3.08043 13.5485 2.98739 13.5418C2.89434 13.535 2.80502 13.5024 2.72954 13.4476C2.65407 13.3928 2.59543 13.3179 2.56027 13.2315C2.52511 13.1451 2.51483 13.0506 2.53058 12.9586L3.26608 8.67063L0.15108 5.63513C0.0842192 5.56998 0.0369292 5.48743 0.0145635 5.3968C-0.00780223 5.30617 -0.00435045 5.21109 0.0245281 5.12232C0.0534066 5.03355 0.106559 4.95464 0.177967 4.89451C0.249376 4.83439 0.336189 4.79546 0.42858 4.78213L4.73308 4.15713L6.65808 0.256125C6.82658 -0.085375 7.38658 -0.085375 7.55508 0.256125L9.48008 4.15713L13.7846 4.78213C13.8768 4.79581 13.9633 4.83493 14.0345 4.8951C14.1056 4.95526 14.1586 5.03408 14.1874 5.1227C14.2163 5.21132 14.2198 5.30623 14.1977 5.39675C14.1755 5.48727 14.1286 5.56982 14.0621 5.63513Z" fill="#CB4C4E" />
      </svg>
    )
    case MAIL:
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="30"
          height="30"
          viewBox="0 0 30 30"
          fill="none"
        >
          <path
            d="M5 5H25C26.375 5 27.5 6.125 27.5 7.5V22.5C27.5 23.875 26.375 25 25 25H5C3.625 25 2.5 23.875 2.5 22.5V7.5C2.5 6.125 3.625 5 5 5Z"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
          />
          <path
            d="M27.5 7.5L15 16.25L2.5 7.5"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
          />
        </svg>
      );
    case UPLOAD_PHOTO:
      return (
        <svg
          width="175"
          height="72"
          viewBox="0 0 175 72"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g filter="url(#filter0_d_911_2834)">
            <rect
              fill="none"
              x="10"
              y="5"
              width="155"
              height="52"
              shapeRendering="crispEdges"
            />
            <rect
              fill="none"
              x="10.5"
              y="5.5"
              width="154"
              height="51"
              stroke="#DCDCDC"
              shapeRendering="crispEdges"
            />
            <path
              fill="none"
              d="M53 27.25V25.75C53 25.3522 53.158 24.9706 53.4393 24.6893C53.7206 24.408 54.1022 24.25 54.5 24.25H63.5C63.8978 24.25 64.2794 24.408 64.5607 24.6893C64.842 24.9706 65 25.3522 65 25.75V27.25M55.25 31.75L59 28M59 28L62.75 31.75M59 28V37"
              stroke="#28282B"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M78.616 37.24C77.7733 37.24 77.0267 37.064 76.376 36.712C75.736 36.3493 75.2347 35.8533 74.872 35.224C74.5093 34.584 74.328 33.848 74.328 33.016V25.8H75.688V33.016C75.688 33.6027 75.8107 34.1253 76.056 34.584C76.312 35.032 76.664 35.384 77.112 35.64C77.56 35.8853 78.072 36.008 78.648 36.008C79.2347 36.008 79.752 35.8853 80.2 35.64C80.6587 35.384 81.0107 35.032 81.256 34.584C81.512 34.1253 81.64 33.6027 81.64 33.016V25.8H82.984V33.016C82.984 33.848 82.8027 34.584 82.44 35.224C82.0773 35.8533 81.5653 36.3493 80.904 36.712C80.2427 37.064 79.48 37.24 78.616 37.24ZM85.5125 40.2V29H86.7125L86.7925 30.472V40.2H85.5125ZM89.4965 37.192C88.8245 37.192 88.2325 37.016 87.7205 36.664C87.2192 36.312 86.8298 35.8213 86.5525 35.192C86.2752 34.552 86.1365 33.8213 86.1365 33C86.1365 32.168 86.2752 31.4373 86.5525 30.808C86.8298 30.1787 87.2192 29.688 87.7205 29.336C88.2325 28.984 88.8245 28.808 89.4965 28.808C90.2112 28.808 90.8405 28.984 91.3845 29.336C91.9285 29.688 92.3498 30.1787 92.6485 30.808C92.9578 31.4373 93.1125 32.168 93.1125 33C93.1125 33.8213 92.9578 34.552 92.6485 35.192C92.3498 35.8213 91.9285 36.312 91.3845 36.664C90.8405 37.016 90.2112 37.192 89.4965 37.192ZM89.2085 36.024C89.7098 36.024 90.1525 35.896 90.5365 35.64C90.9312 35.384 91.2405 35.0267 91.4645 34.568C91.6992 34.1093 91.8165 33.5867 91.8165 33C91.8165 32.4133 91.7045 31.8907 91.4805 31.432C91.2672 30.9733 90.9632 30.616 90.5685 30.36C90.1738 30.104 89.7258 29.976 89.2245 29.976C88.7552 29.976 88.3338 30.104 87.9605 30.36C87.5978 30.616 87.3098 30.9733 87.0965 31.432C86.8938 31.8907 86.7925 32.4133 86.7925 33C86.7925 33.5867 86.8938 34.1093 87.0965 34.568C87.3098 35.0267 87.5978 35.384 87.9605 35.64C88.3232 35.896 88.7392 36.024 89.2085 36.024ZM94.8856 37V25.8H96.1656V37H94.8856ZM103.329 37L103.265 35.688V32.776C103.265 32.1467 103.196 31.6293 103.057 31.224C102.919 30.808 102.7 30.4933 102.401 30.28C102.103 30.0667 101.713 29.96 101.233 29.96C100.796 29.96 100.417 30.0507 100.097 30.232C99.7879 30.4027 99.5319 30.68 99.3293 31.064L98.1773 30.616C98.3799 30.2427 98.6253 29.9227 98.9133 29.656C99.2013 29.3787 99.5373 29.1707 99.9213 29.032C100.305 28.8827 100.743 28.808 101.233 28.808C101.98 28.808 102.593 28.9573 103.073 29.256C103.564 29.544 103.932 29.976 104.177 30.552C104.423 31.1173 104.54 31.8213 104.529 32.664L104.513 37H103.329ZM100.929 37.192C99.9906 37.192 99.2546 36.9787 98.7213 36.552C98.1986 36.1147 97.9373 35.512 97.9373 34.744C97.9373 33.9333 98.2039 33.3147 98.7373 32.888C99.2813 32.4507 100.039 32.232 101.009 32.232H103.297V33.304H101.297C100.551 33.304 100.017 33.4267 99.6973 33.672C99.3879 33.9173 99.2333 34.2693 99.2333 34.728C99.2333 35.144 99.3879 35.4747 99.6973 35.72C100.007 35.9547 100.439 36.072 100.993 36.072C101.452 36.072 101.852 35.976 102.193 35.784C102.535 35.5813 102.796 35.2987 102.977 34.936C103.169 34.5627 103.265 34.1253 103.265 33.624H103.809C103.809 34.712 103.564 35.5813 103.073 36.232C102.583 36.872 101.868 37.192 100.929 37.192ZM110.094 37.192C109.315 37.192 108.622 37.016 108.014 36.664C107.416 36.3013 106.947 35.8053 106.606 35.176C106.264 34.5467 106.094 33.8213 106.094 33C106.094 32.1787 106.259 31.4533 106.59 30.824C106.931 30.1947 107.4 29.704 107.998 29.352C108.606 28.9893 109.294 28.808 110.062 28.808C110.851 28.808 111.544 28.9893 112.142 29.352C112.75 29.704 113.219 30.1947 113.55 30.824C113.891 31.4533 114.062 32.1787 114.062 33C114.062 33.8213 113.891 34.5467 113.55 35.176C113.219 35.8053 112.755 36.3013 112.158 36.664C111.56 37.016 110.872 37.192 110.094 37.192ZM110.094 36.008C110.627 36.008 111.091 35.88 111.486 35.624C111.88 35.368 112.19 35.016 112.414 34.568C112.648 34.12 112.766 33.5973 112.766 33C112.766 32.4027 112.648 31.88 112.414 31.432C112.19 30.984 111.875 30.632 111.47 30.376C111.064 30.12 110.595 29.992 110.062 29.992C109.539 29.992 109.075 30.12 108.67 30.376C108.275 30.632 107.96 30.984 107.726 31.432C107.502 31.88 107.39 32.4027 107.39 33C107.39 33.5867 107.502 34.1093 107.726 34.568C107.96 35.016 108.28 35.368 108.686 35.624C109.102 35.88 109.571 36.008 110.094 36.008ZM121.759 37L121.695 35.512V25.8H122.975V37H121.759ZM118.991 37.192C118.276 37.192 117.647 37.016 117.103 36.664C116.559 36.312 116.132 35.8213 115.823 35.192C115.524 34.552 115.375 33.8213 115.375 33C115.375 32.168 115.524 31.4373 115.823 30.808C116.132 30.1787 116.559 29.688 117.103 29.336C117.647 28.984 118.276 28.808 118.991 28.808C119.663 28.808 120.249 28.984 120.751 29.336C121.263 29.688 121.657 30.1787 121.935 30.808C122.212 31.4373 122.351 32.168 122.351 33C122.351 33.8213 122.212 34.552 121.935 35.192C121.657 35.8213 121.263 36.312 120.751 36.664C120.249 37.016 119.663 37.192 118.991 37.192ZM119.279 36.024C119.748 36.024 120.164 35.896 120.527 35.64C120.889 35.384 121.172 35.0267 121.375 34.568C121.588 34.1093 121.695 33.5867 121.695 33C121.695 32.4133 121.588 31.8907 121.375 31.432C121.172 30.9733 120.889 30.616 120.527 30.36C120.164 30.104 119.743 29.976 119.263 29.976C118.761 29.976 118.313 30.104 117.919 30.36C117.535 30.616 117.231 30.9733 117.007 31.432C116.783 31.8907 116.671 32.4133 116.671 33C116.671 33.5867 116.783 34.1093 117.007 34.568C117.231 35.0267 117.54 35.384 117.935 35.64C118.329 35.896 118.777 36.024 119.279 36.024Z"
              fill="#28282B"
            />
          </g>
          <defs>
            <filter
              id="filter0_d_911_2834"
              x="0"
              y="0"
              width="175"
              height="72"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="5" />
              <feGaussianBlur stdDeviation="5" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_911_2834"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_911_2834"
                result="shape"
              />
            </filter>
          </defs>
        </svg>
      );
    case WHITE_VINYLE:
      return (
        <svg
          width="30"
          height="30"
          viewBox="0 0 30 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15 0C6.72891 0 0 6.72891 0 15C0 23.2711 6.72891 30 15 30C23.2711 30 30 23.2711 30 15C30 6.72891 23.2711 0 15 0ZM25.5382 14.5312C25.797 14.5312 26.007 14.7413 26.007 15C26.007 21.0694 21.0694 26.007 15 26.007C14.7413 26.007 14.5312 25.797 14.5312 25.5382C14.5312 25.2795 14.7413 25.0695 15 25.0695C20.5521 25.0695 25.0695 20.5523 25.0695 15C25.0695 14.8757 25.1188 14.7565 25.2067 14.6685C25.2947 14.5806 25.4139 14.5312 25.5382 14.5312ZM23.6782 14.5312C23.937 14.5312 24.147 14.7413 24.147 15C24.147 20.0438 20.0435 24.147 15 24.147C14.7413 24.147 14.5312 23.937 14.5312 23.6782C14.5312 23.4195 14.7413 23.2095 15 23.2095C19.5267 23.2095 23.2095 19.5267 23.2095 15C23.2095 14.7413 23.4195 14.5312 23.6782 14.5312ZM21.7842 14.5312C22.043 14.5312 22.253 14.7413 22.253 15C22.253 18.9991 18.9991 22.253 15 22.253C14.7413 22.253 14.5312 22.043 14.5312 21.7842C14.5312 21.5255 14.7413 21.3155 15 21.3155C18.4823 21.3155 21.3155 18.4823 21.3155 15C21.3155 14.7413 21.5255 14.5312 21.7842 14.5312ZM2.60695 15.4688C2.3482 15.4688 2.1382 15.2587 2.1382 15C2.1382 7.90805 7.90805 2.1382 15 2.1382C15.2587 2.1382 15.4688 2.3482 15.4688 2.60695C15.4688 2.8657 15.2587 3.0757 15 3.0757C8.42484 3.0757 3.0757 8.42484 3.0757 15C3.0757 15.1243 3.02632 15.2435 2.93841 15.3315C2.8505 15.4194 2.73127 15.4688 2.60695 15.4688ZM4.4618 15.4688C4.20305 15.4688 3.99305 15.2587 3.99305 15C3.99305 8.93062 8.93062 3.99305 15 3.99305C15.2587 3.99305 15.4688 4.20305 15.4688 4.4618C15.4688 4.72055 15.2587 4.93055 15 4.93055C9.44789 4.93055 4.93055 9.44766 4.93055 15C4.93055 15.1243 4.88116 15.2435 4.79325 15.3315C4.70535 15.4194 4.58612 15.4688 4.4618 15.4688ZM6.3218 15.4688C6.06305 15.4688 5.85305 15.2587 5.85305 15C5.85305 9.95625 9.95648 5.85305 15 5.85305C15.2587 5.85305 15.4688 6.06305 15.4688 6.3218C15.4688 6.58055 15.2587 6.79055 15 6.79055C10.4733 6.79055 6.79055 10.4733 6.79055 15C6.79055 15.2587 6.58055 15.4688 6.3218 15.4688ZM8.21578 15.4688C7.95703 15.4688 7.74703 15.2587 7.74703 15C7.74703 11.0009 11.0009 7.74703 15 7.74703C15.2587 7.74703 15.4688 7.95703 15.4688 8.21578C15.4688 8.47453 15.2587 8.68453 15 8.68453C11.5177 8.68453 8.68453 11.5177 8.68453 15C8.68453 15.2587 8.47453 15.4688 8.21578 15.4688ZM10.3294 15C10.3294 12.4247 12.4245 10.3294 15 10.3294C17.5755 10.3294 19.6706 12.4247 19.6706 15C19.6706 17.5753 17.5753 19.6706 15 19.6706C12.4247 19.6706 10.3294 17.5753 10.3294 15ZM15 27.8618C14.7413 27.8618 14.5312 27.6518 14.5312 27.393C14.5312 27.1343 14.7413 26.9243 15 26.9243C21.5752 26.9243 26.9243 21.5752 26.9243 15C26.9243 14.7413 27.1343 14.5312 27.393 14.5312C27.6518 14.5312 27.8618 14.7413 27.8618 15C27.8618 22.092 22.092 27.8618 15 27.8618Z"
            fill="white"
          />
          <path
            d="M15.0015 13.834C14.3589 13.834 13.8359 14.3566 13.8359 14.9993C13.8359 15.642 14.3586 16.1646 15.0015 16.1646C15.644 16.1646 16.1669 15.642 16.1669 14.9993C16.1669 14.3566 15.644 13.834 15.0015 13.834Z"
            fill="white"
          />
        </svg>
      );
    case GLOBE:
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_405_593)">
            <path
              fill="none"
              d="M9.9974 18.3346C14.5998 18.3346 18.3307 14.6037 18.3307 10.0013C18.3307 5.39893 14.5998 1.66797 9.9974 1.66797C5.39502 1.66797 1.66406 5.39893 1.66406 10.0013C1.66406 14.6037 5.39502 18.3346 9.9974 18.3346Z"
              stroke="#CB4C4E"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              fill="none"
              d="M1.66406 10H18.3307"
              stroke="#CB4C4E"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              fill="none"
              d="M9.9974 1.66797C12.0818 3.94993 13.2664 6.91133 13.3307 10.0013C13.2664 13.0913 12.0818 16.0527 9.9974 18.3346C7.913 16.0527 6.72844 13.0913 6.66406 10.0013C6.72844 6.91133 7.913 3.94993 9.9974 1.66797Z"
              stroke="#CB4C4E"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_405_593">
              <rect width="20" height="20" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case FLAG_EN:
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M24 4H0V20.0002H24V4Z" fill="#F0F0F0" />
          <path
            d="M13.5 4H10.5V10.5H0V13.5H10.5V19.9999H13.5V13.5H24V10.5H13.5V4Z"
            fill="#D80027"
          />
          <path d="M18.459 14.7822L24.0003 17.8608V14.7822H18.459Z" fill="#0052B4" />
          <path
            d="M14.6084 14.7822L23.9997 19.9996V18.5243L17.2641 14.7822H14.6084Z"
            fill="#0052B4"
          />
          <path d="M21.4982 19.9999L14.6084 16.1719V19.9999H21.4982Z" fill="#0052B4" />
          <path
            d="M14.6084 14.7822L23.9997 19.9996V18.5243L17.2641 14.7822H14.6084Z"
            fill="#F0F0F0"
          />
          <path
            d="M14.6084 14.7822L23.9997 19.9996V18.5243L17.2641 14.7822H14.6084Z"
            fill="#D80027"
          />
          <path d="M4.23473 14.7822L0 17.1349V14.7822H4.23473Z" fill="#0052B4" />
          <path d="M9.39174 15.4463V20.0002H1.19531L9.39174 15.4463Z" fill="#0052B4" />
          <path d="M6.73561 14.7822L0 18.5243V19.9996L9.39131 14.7822H6.73561Z" fill="#D80027" />
          <path d="M5.54133 9.21723L0 6.13867V9.21723H5.54133Z" fill="#0052B4" />
          <path d="M9.39131 9.21737L0 4V5.47534L6.73561 9.21737H9.39131Z" fill="#0052B4" />
          <path d="M2.50195 4L9.39174 7.828V4H2.50195Z" fill="#0052B4" />
          <path d="M9.39131 9.21737L0 4V5.47534L6.73561 9.21737H9.39131Z" fill="#F0F0F0" />
          <path d="M9.39131 9.21737L0 4V5.47534L6.73561 9.21737H9.39131Z" fill="#D80027" />
          <path d="M19.7656 9.21691L24.0004 6.86426V9.21691H19.7656Z" fill="#0052B4" />
          <path d="M14.6084 8.55395V4H22.8048L14.6084 8.55395Z" fill="#0052B4" />
          <path d="M17.2641 9.21737L23.9997 5.47534V4L14.6084 9.21737H17.2641Z" fill="#D80027" />
        </svg>
      );

    case FLAG_NL: return (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M24 9.38008H0V4.55248C0 4.32397 0.185297 4.13867 0.413812 4.13867H23.5862C23.8147 4.13867 24 4.32397 24 4.55248L24 9.38008Z" fill="#FF4B55" />
        <path d="M23.5861 19.8625H0.413812C0.185297 19.8625 0 19.6772 0 19.4486V14.6211H24V19.4486C24 19.6772 23.8147 19.8625 23.5861 19.8625Z" fill="#41479B" />
        <path d="M24 9.37988H0V14.621H24V9.37988Z" fill="#F5F5F5" />
      </svg>

    )
    case CONTACT: return (
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill='none' d="M15.75 11.25C15.75 11.6478 15.592 12.0294 15.3107 12.3107C15.0294 12.592 14.6478 12.75 14.25 12.75H5.25L2.25 15.75V3.75C2.25 3.35218 2.40804 2.97064 2.68934 2.68934C2.97064 2.40804 3.35218 2.25 3.75 2.25H14.25C14.6478 2.25 15.0294 2.40804 15.3107 2.68934C15.592 2.97064 15.75 3.35218 15.75 3.75V11.25Z" stroke="#28282B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>

    )
    case LOCATION: return (
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill='none' d="M14 6.66797C14 11.3346 8 15.3346 8 15.3346C8 15.3346 2 11.3346 2 6.66797C2 5.07667 2.63214 3.55055 3.75736 2.42533C4.88258 1.30011 6.4087 0.667969 8 0.667969C9.5913 0.667969 11.1174 1.30011 12.2426 2.42533C13.3679 3.55055 14 5.07667 14 6.66797Z" stroke="#CB4C4E" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
        <path fill='none' d="M8 8.66797C9.10457 8.66797 10 7.77254 10 6.66797C10 5.5634 9.10457 4.66797 8 4.66797C6.89543 4.66797 6 5.5634 6 6.66797C6 7.77254 6.89543 8.66797 8 8.66797Z" stroke="#CB4C4E" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>

    )
    case CHEVRON_DOWN: return (
      <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill='none' d="M1 1L7 7L13 1" stroke="#28282B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>

    )
    case ARROW_LINE_ARROW: return (
      <svg width="21" height="13" viewBox="0 0 21 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill='none' d="M1 6.65625L19.2017 6.65625" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path fill='none' d="M14.4102 1L19.9984 6.5L14.4102 12" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    )
    case PAPER_PLAIN: return (
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.27812 10.1206L6.01345 13.8433C6.39212 13.8433 6.55612 13.6806 6.75278 13.4853L8.52812 11.7886L12.2068 14.4826C12.8815 14.8586 13.3568 14.6606 13.5388 13.8619L15.9535 2.54728L15.9541 2.54661C16.1681 1.54928 15.5935 1.15928 14.9361 1.40394L0.742785 6.83794C-0.225881 7.21394 -0.211215 7.75394 0.578119 7.99861L4.20678 9.12728L12.6355 3.85328C13.0321 3.59061 13.3928 3.73594 13.0961 3.99861L6.27812 10.1206Z" fill="white" />
      </svg>

    )
    case CART: return (
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_872_940)">
          <path fill='none' d="M6.75 16.5C7.16421 16.5 7.5 16.1642 7.5 15.75C7.5 15.3358 7.16421 15 6.75 15C6.33579 15 6 15.3358 6 15.75C6 16.1642 6.33579 16.5 6.75 16.5Z" stroke="#CB4C4E" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
          <path fill='none' d="M15 16.5C15.4142 16.5 15.75 16.1642 15.75 15.75C15.75 15.3358 15.4142 15 15 15C14.5858 15 14.25 15.3358 14.25 15.75C14.25 16.1642 14.5858 16.5 15 16.5Z" stroke="#CB4C4E" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
          <path fill='none' d="M0.75 0.75H3.75L5.76 10.7925C5.82858 11.1378 6.01643 11.448 6.29066 11.6687C6.56489 11.8895 6.90802 12.0067 7.26 12H14.55C14.902 12.0067 15.2451 11.8895 15.5193 11.6687C15.7936 11.448 15.9814 11.1378 16.05 10.7925L17.25 4.5H4.5" stroke="#CB4C4E" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
        </g>
        <defs>
          <clipPath id="clip0_872_940">
            <rect width="18" height="18" fill="white" />
          </clipPath>
        </defs>
      </svg>

    )
    case FLAG_NL:
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M24 9.38008H0V4.55248C0 4.32397 0.185297 4.13867 0.413812 4.13867H23.5862C23.8147 4.13867 24 4.32397 24 4.55248L24 9.38008Z"
            fill="#FF4B55"
          />
          <path
            d="M23.5861 19.8625H0.413812C0.185297 19.8625 0 19.6772 0 19.4486V14.6211H24V19.4486C24 19.6772 23.8147 19.8625 23.5861 19.8625Z"
            fill="#41479B"
          />
          <path d="M24 9.37988H0V14.621H24V9.37988Z" fill="#F5F5F5" />
        </svg>
      );
    case CONTACT:
      return (
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill="none"
            d="M15.75 11.25C15.75 11.6478 15.592 12.0294 15.3107 12.3107C15.0294 12.592 14.6478 12.75 14.25 12.75H5.25L2.25 15.75V3.75C2.25 3.35218 2.40804 2.97064 2.68934 2.68934C2.97064 2.40804 3.35218 2.25 3.75 2.25H14.25C14.6478 2.25 15.0294 2.40804 15.3107 2.68934C15.592 2.97064 15.75 3.35218 15.75 3.75V11.25Z"
            stroke="#28282B"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case LOCATION:
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill="none"
            d="M14 6.66797C14 11.3346 8 15.3346 8 15.3346C8 15.3346 2 11.3346 2 6.66797C2 5.07667 2.63214 3.55055 3.75736 2.42533C4.88258 1.30011 6.4087 0.667969 8 0.667969C9.5913 0.667969 11.1174 1.30011 12.2426 2.42533C13.3679 3.55055 14 5.07667 14 6.66797Z"
            stroke="#CB4C4E"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            fill="none"
            d="M8 8.66797C9.10457 8.66797 10 7.77254 10 6.66797C10 5.5634 9.10457 4.66797 8 4.66797C6.89543 4.66797 6 5.5634 6 6.66797C6 7.77254 6.89543 8.66797 8 8.66797Z"
            stroke="#CB4C4E"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case CHEVRON_DOWN:
      return (
        <svg
          width="14"
          height="8"
          viewBox="0 0 14 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill="none"
            d="M1 1L7 7L13 1"
            stroke="#28282B"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case ARROW_LINE_ARROW:
      return (
        <svg
          width="21"
          height="13"
          viewBox="0 0 21 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill="none"
            d="M1 6.65625L19.2017 6.65625"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            fill="none"
            d="M14.4102 1L19.9984 6.5L14.4102 12"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case PAPER_PLAIN:
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.27812 10.1206L6.01345 13.8433C6.39212 13.8433 6.55612 13.6806 6.75278 13.4853L8.52812 11.7886L12.2068 14.4826C12.8815 14.8586 13.3568 14.6606 13.5388 13.8619L15.9535 2.54728L15.9541 2.54661C16.1681 1.54928 15.5935 1.15928 14.9361 1.40394L0.742785 6.83794C-0.225881 7.21394 -0.211215 7.75394 0.578119 7.99861L4.20678 9.12728L12.6355 3.85328C13.0321 3.59061 13.3928 3.73594 13.0961 3.99861L6.27812 10.1206Z"
            fill="white"
          />
        </svg>
      );
    case CART:
      return (
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_872_940)">
            <path
              fill="none"
              d="M6.75 16.5C7.16421 16.5 7.5 16.1642 7.5 15.75C7.5 15.3358 7.16421 15 6.75 15C6.33579 15 6 15.3358 6 15.75C6 16.1642 6.33579 16.5 6.75 16.5Z"
              stroke="#CB4C4E"
              strokeWidth="1.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              fill="none"
              d="M15 16.5C15.4142 16.5 15.75 16.1642 15.75 15.75C15.75 15.3358 15.4142 15 15 15C14.5858 15 14.25 15.3358 14.25 15.75C14.25 16.1642 14.5858 16.5 15 16.5Z"
              stroke="#CB4C4E"
              strokeWidth="1.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              fill="none"
              d="M0.75 0.75H3.75L5.76 10.7925C5.82858 11.1378 6.01643 11.448 6.29066 11.6687C6.56489 11.8895 6.90802 12.0067 7.26 12H14.55C14.902 12.0067 15.2451 11.8895 15.5193 11.6687C15.7936 11.448 15.9814 11.1378 16.05 10.7925L17.25 4.5H4.5"
              stroke="#CB4C4E"
              strokeWidth="1.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_872_940">
              <rect width="18" height="18" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case ACC_PLUS:
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8 3.33301V12.6663"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="square"
            strokeLinejoin="round"
          />
          <path
            d="M3.33301 8H12.6663"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="square"
            strokeLinejoin="round"
          />
        </svg>
      );

    case FAV_HEART:
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.8941 3.07357C13.5536 2.73291 13.1493 2.46267 12.7043 2.2783C12.2593 2.09392 11.7824 1.99902 11.3007 1.99902C10.8191 1.99902 10.3421 2.09392 9.89716 2.2783C9.45219 2.46267 9.0479 2.73291 8.7074 3.07357L8.00073 3.78024L7.29406 3.07357C6.60627 2.38578 5.67342 1.99938 4.70073 1.99938C3.72804 1.99938 2.79519 2.38578 2.1074 3.07357C1.4196 3.76137 1.0332 4.69422 1.0332 5.66691C1.0332 6.6396 1.4196 7.57245 2.1074 8.26024L2.81406 8.96691L8.00073 14.1536L13.1874 8.96691L13.8941 8.26024C14.2347 7.91974 14.505 7.51545 14.6893 7.07048C14.8737 6.6255 14.9686 6.14857 14.9686 5.66691C14.9686 5.18525 14.8737 4.70831 14.6893 4.26334C14.505 3.81836 14.2347 3.41408 13.8941 3.07357Z"
            stroke="#28282B"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case RIGHT_ARROW:
      return (
        <svg
          className={classes}
          width="21"
          height="13"
          viewBox="0 0 21 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1 6.65625L19.2017 6.65625"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill='none'
          />
          <path
            fill='none'
            d="M14.4102 1L19.9984 6.5L14.4102 12"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case DROPDOWNARROW:
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill="none"
            d="M5 7.5L10 12.5L15 7.5"
            stroke="#28282B"
            strokeWidth="1.25"
            strokeLinecap="square"
            strokeLinejoin="round"
          />
        </svg>
      );
    case BRAND_AMEX:
      return (
        <svg
          className={classes}
          height="16"
          viewBox="0 0 24 16"
          width="24"
          xmlns="http://www.w3.org/2000/svg"
          {...roleInfo}
        >
          <g fill="none" fillRule="evenodd">
            <rect fill="#016fd0" height="16" rx="2" width="24" />
            <path
              d="M13.764 13.3939V7.6925l10.1476.009v1.575l-1.1729 1.2534 1.1729 1.2648v1.6083H22.039l-.9952-1.0981-.9881 1.1023z"
              fill="#fffffe"
            />
            <path
              d="M14.4418 12.7688V8.3199h3.7723v1.0249h-2.5509v.6957h2.49v1.0078h-2.49v.6833h2.5509v1.0372z"
              fill="#016fd0"
            />
            <path
              d="M18.1953 12.7688l2.0873-2.227L18.1952 8.32h1.6156l1.2755 1.41 1.2791-1.41h1.5462v.035l-2.0429 2.1868 2.0429 2.1639v.0631h-1.5617l-1.2981-1.4242-1.2848 1.4242z"
              fill="#016fd0"
            />
            <path
              d="M14.2373 2.632h2.4461l.8591 1.9508V2.632h3.0199l.5207 1.4615.5226-1.4615h2.3059v5.7013H11.7251z"
              fill="#fffffe"
            />
            <g fill="#016fd0">
              <path d="M14.7005 3.2514l-1.974 4.4451h1.3539l.3724-.8901h2.018l.372.8901h1.3877l-1.9658-4.4451zm.1696 2.5574l.592-1.415.5916 1.415z" />
              <path d="M18.212 7.6957v-4.445l1.903.0065.9794 2.7327.9856-2.7392h1.8316v4.445l-1.1786.0105V4.6528l-1.1126 3.043h-1.0758L19.409 4.6423v3.0533z" />
            </g>
          </g>
        </svg>
      );
    case BRAND_DINERS:
      return (
        <svg
          className={classes}
          width="24"
          height="16"
          viewBox="0 0 24 16"
          xmlns="http://www.w3.org/2000/svg"
          {...roleInfo}
        >
          <g fillRule="nonzero" fill="none">
            <path
              d="M21.9972 15.75h.0022c.955.0081 1.7387-.7727 1.7506-1.7458V2.0063c-.0038-.4706-.1911-.9201-.5203-1.2495a1.7197 1.7197 0 0 0-1.2325-.5067H2.0006C1.5411.246 1.0986.4283.7703.7568.441 1.0862.2538 1.5357.25 2.0043v11.9894c.0038.4706.1911.9201.5203 1.2495a1.7197 1.7197 0 0 0 1.2325.5067h19.9944zm-.001.5h-.0011.0021-.001z"
              strokeOpacity=".2"
              stroke="#000"
              strokeWidth=".5"
              fill="#FFF"
            />
            <path
              d="M10.0021 2.0518v-.016h4v.016c3.1354.2294 5.5621 2.8402 5.5621 5.984s-2.4267 5.7546-5.562 5.984v.016h-4v-.016C6.8666 13.7904 4.44 11.1796 4.44 8.0358s2.4267-5.7546 5.5621-5.984z"
              fill="#0165AC"
            />
            <path
              d="M11.6021 11.4278a3.6 3.6 0 0 0 0-6.784v6.784zm-2.4-6.784a3.6 3.6 0 0 0 0 6.784v-6.784zm1.2 8.592c-2.8719 0-5.2-2.3281-5.2-5.2s2.3281-5.2 5.2-5.2 5.2 2.3281 5.2 5.2-2.3281 5.2-5.2 5.2z"
              fill="#FFF"
            />
          </g>
        </svg>
      );
    case BRAND_DISCOVERY:
      return (
        <svg
          className={classes}
          width="24"
          height="16"
          viewBox="0 0 24 16"
          xmlns="http://www.w3.org/2000/svg"
          {...roleInfo}
        >
          <g fillRule="nonzero" fill="none">
            <path
              d="M21.9972 15.75h.0022c.955.0081 1.7387-.7727 1.7506-1.7458V2.0063c-.0038-.4706-.1911-.9201-.5203-1.2495a1.7197 1.7197 0 0 0-1.2325-.5067H2.0006C1.5411.246 1.0986.4283.7703.7568.441 1.0862.2538 1.5357.25 2.0043v11.9894c.0038.4706.1911.9201.5203 1.2495a1.7197 1.7197 0 0 0 1.2325.5067h19.9944zm-.001.5h-.0011.0021-.001z"
              strokeOpacity=".2"
              stroke="#000"
              strokeWidth=".5"
              fill="#FFF"
            />
            <path
              d="M12.6124 16h9.3848A1.9862 1.9862 0 0 0 24 14.0302v-2.3586a38.7393 38.7393 0 0 1-11.3876 4.3282z"
              fill="#F27712"
            />
            <path
              d="M23.1724 9.2965H22.32l-.96-1.2662h-.091v1.2662h-.6952V6.1517H21.6c.8028 0 1.2662.331 1.2662.9268 0 .4883-.2896.8028-.811.9021l1.1172 1.3159zm-1.0262-2.1931c0-.3062-.2317-.4635-.662-.4635h-.2152v.9518h.1986c.4469 0 .6786-.1656.6786-.4883zm-4.0055-.9517h1.9696v.5296H18.836v.7035h1.2248v.5379h-1.2248v.8524h1.2744v.5297h-1.9696V6.1517zm-2.2345 3.2275L14.4 6.1434h.7614l.9517 2.1186.96-2.1186h.7448l-1.5227 3.2358h-.389zm-6.298-.0082c-1.0592 0-1.8868-.72-1.8868-1.6552 0-.9104.8441-1.647 1.9034-1.647.298 0 .5462.058.8524.1904v.7283a1.2414 1.2414 0 0 0-.869-.3558c-.662 0-1.1668.48-1.1668 1.084 0 .6373.4965 1.0925 1.2 1.0925.3145 0 .5545-.0993.8358-.3476v.7283c-.3144.1324-.5793.182-.869.182zm-2.102-1.0345c0 .6124-.5048 1.0345-1.2331 1.0345-.5297 0-.9103-.1821-1.2331-.5959l.4552-.389c.1572.2814.422.4221.753.4221.3146 0 .538-.1903.538-.4386 0-.1407-.0662-.2483-.2069-.331a2.88 2.88 0 0 0-.48-.1821c-.6538-.207-.8772-.4304-.8772-.869 0-.513.48-.902 1.109-.902.3972 0 .753.124 1.051.3558l-.3642.4138a.7614.7614 0 0 0-.5627-.2483c-.298 0-.5131.149-.5131.3476 0 .1655.1241.2566.5379.3973.7945.2482 1.0262.48 1.0262.993v-.0082zm-3.418-2.1848h.6952v3.153h-.6951v-3.153zm-2.2344 3.153H.8276v-3.153h1.0262c1.1255 0 1.9034.6455 1.9034 1.5724 0 .4717-.2317.9186-.6372 1.2165-.3476.2483-.7366.3642-1.2745.3642h.0083zm.811-2.3668c-.2317-.1821-.4965-.2483-.9517-.2483h-.1903V8.775h.1903c.4469 0 .7283-.0828.9517-.2483.24-.1986.3807-.4965.3807-.8027 0-.3062-.1407-.5959-.3807-.7862z"
              fill="#000"
            />
            <path
              d="M12.4138 6.0689c-.9104 0-1.6552.7283-1.6552 1.6303 0 .96.7117 1.68 1.6552 1.68.9269 0 1.6552-.7282 1.6552-1.6551 0-.927-.72-1.6552-1.6552-1.6552z"
              fill="#F27712"
            />
          </g>
        </svg>
      );
    case BRAND_JCB:
      return (
        <svg
          className={classes}
          height="16"
          viewBox="0 0 23 16"
          width="23"
          xmlns="http://www.w3.org/2000/svg"
          {...roleInfo}
        >
          <g fill="none">
            <path
              d="M.2054 16h4.5178c1.0278 0 2.259-1.1947 2.259-2.1333V0h-4.518C1.4366 0 .2055 1.1947.2055 3.2z"
              fill="#047ab1"
            />
            <path
              d="M2.7692 10.816a9.7709 9.7709 0 0 1-2.5638-.3413V9.3013c.6467.3777 1.386.5909 2.146.6187.8696 0 1.3553-.576 1.3553-1.3653V5.3333h2.146v3.2214c0 1.2586-.7003 2.2613-3.0835 2.2613z"
              fill="#fff"
            />
            <path
              d="M8.1116 16h4.5179c1.0278 0 2.2589-1.1947 2.2589-2.1333V0h-4.5179C9.3427 0 8.1116 1.1947 8.1116 3.2z"
              fill="#d42d06"
            />
            <path
              d="M8.1116 6.08c.6551-.5973 1.7846-.9707 3.6143-.8853.994.0426 2.033.32 2.033.32v1.184c-.5943-.3395-1.2623-.5474-1.954-.608C10.4158 5.9733 9.5687 6.7093 9.5687 8s.8471 2.0267 2.2364 1.92c.692-.066 1.3596-.2774 1.954-.6187v1.1734s-1.0392.288-2.0331.3306c-1.8297.0854-2.9592-.288-3.6143-.8853z"
              fill="#fff"
            />
            <path
              d="M16.0179 16h4.5178c1.0278 0 2.259-1.1947 2.259-2.1333V0h-4.518C17.249 0 16.018 1.1947 16.018 3.2z"
              fill="#67b637"
            />
            <path
              d="M21.6652 9.28c0 .8533-.7003 1.3867-1.6377 1.3867h-4.0096V5.3333h3.6481l.2598.0107c.8245.0427 1.4344.5013 1.4344 1.2907 0 .6186-.4179 1.152-1.1746 1.28v.032c.8358.0533 1.4796.5546 1.4796 1.3333zM18.785 6.176a1.0871 1.0871 0 0 0-.1468-.0107H17.283v1.344h1.5021c.2824-.064.5196-.3093.5196-.672 0-.3626-.2372-.608-.5196-.6613zm.1695 2.176a1.0276 1.0276 0 0 0-.1808-.0107H17.283v1.4614h1.4908l.1808-.0214c.2823-.064.5195-.3413.5195-.7146 0-.3734-.2259-.64-.5195-.7147z"
              fill="#fff"
            />
          </g>
        </svg>
      );
    case BRAND_MASTERCARD:
      return (
        <svg
          className={classes}
          height="16"
          viewBox="0 0 24 16"
          width="24"
          xmlns="http://www.w3.org/2000/svg"
          {...roleInfo}
        >
          <g fill="none" fillRule="evenodd">
            <rect fill="#252525" height="16" rx="2" width="24" />
            <circle cx="9" cy="8" fill="#eb001b" r="5" />
            <circle cx="15" cy="8" fill="#f79e1b" r="5" />
            <path
              d="M12 3.9996c1.2144.9122 2 2.3646 2 4.0004s-.7856 3.0882-2 4.0004C10.7856 11.0882 10 9.6358 10 8s.7856-3.0882 2-4.0004z"
              fill="#ff5f00"
            />
          </g>
        </svg>
      );
    case BRAND_UNIONPAY:
      return (
        <svg
          className={classes}
          height="16"
          viewBox="0 0 24 16"
          width="24"
          xmlns="http://www.w3.org/2000/svg"
          {...roleInfo}
        >
          <g fill="none">
            <path
              d="M4.5459 0h5.7938c.8087 0 1.3117.7257 1.123 1.619L8.7655 14.3675c-.1904.8902-1.0002 1.6165-1.8095 1.6165H1.1627c-.8076 0-1.3118-.7263-1.1231-1.6165L2.7381 1.619C2.9268.7257 3.7361 0 4.546 0"
              fill="#dd2423"
            />
            <path
              d="M9.8576 0h6.6627c.8086 0 .444.7257.2537 1.619l-2.697 12.7485c-.1892.8902-.1302 1.6165-.9405 1.6165H6.4738c-.8103 0-1.3118-.7263-1.1214-1.6165L8.0493 1.619C8.2408.7257 9.0483 0 9.8576 0"
              fill="#16315e"
            />
            <path
              d="M16.256 0h5.7938c.8098 0 1.3129.7257 1.1226 1.619l-2.697 12.7485c-.1903.8902-1.0006 1.6165-1.8104 1.6165h-5.791c-.8104 0-1.313-.7263-1.1232-1.6165L14.4482 1.619C14.637.7257 15.4457 0 16.256 0"
              fill="#036862"
            />
            <path
              d="M6.059 4.0856c-.5958.0067-.7717 0-.828-.0146-.0216.113-.4236 2.1546-.4247 2.1563-.0866.413-.1496.7075-.3635.8976-.1215.1105-.2633.1639-.4276.1639-.2643 0-.4182-.1445-.444-.4184l-.005-.094s.0805-.5533.0805-.5564c0 0 .422-1.8605.4975-2.1064a.1945.1945 0 0 0 .0061-.028c-.8213.008-.967 0-.977-.0146-.0055.02-.0258.1354-.0258.1354l-.4308 2.097-.037.1778-.0716.5817c0 .1725.0307.3134.092.4325.1963.3776.7563.4342 1.073.4342.4081 0 .791-.0955 1.0497-.2698.449-.292.5666-.7486.6713-1.1544l.0486-.2081s.4347-1.9323.5085-2.1837c.0029-.014.004-.0213.0078-.028zm1.479 1.5588c-.1048 0-.2963.028-.4683.1208-.0624.0353-.1215.076-.1838.1166l.0562-.2234-.0307-.0376c-.3648.0813-.4464.0922-.7834.1444l-.0282.0207c-.0391.357-.0739.6255-.219 1.3274a90.3116 90.3116 0 0 1-.17.778l.0156.0327c.3453-.02.45-.02.7502-.0146l.0242-.029c.0382-.215.0431-.2654.1276-.7009.0396-.2064.1224-.66.1632-.8215.075-.0383.149-.0759.2196-.0759.1682 0 .1477.1615.1412.2259-.0072.108-.0685.4609-.1313.7639l-.042.1955c-.0292.1445-.0612.2848-.0905.428l.0127.0286c.3404-.02.4442-.02.7348-.0146l.0342-.029c.0525-.3358.0679-.4257.1611-.9146l.0469-.2246c.091-.4397.1368-.6626.068-.8442-.073-.2035-.2478-.2526-.4083-.2526zm1.6521.4603c-.181.0383-.2963.0637-.411.0802-.1136.02-.2245.0383-.3993.065l-.0139.0138-.0127.011c-.0182.1434-.0309.2673-.055.413-.0205.1506-.052.3218-.1033.5677-.0397.1882-.0601.2538-.0827.32-.022.0663-.0463.1307-.091.3158l.0105.0171.0087.0157c.1634-.0085.2703-.0146.3802-.0157.1097-.0043.2234 0 .3994.001l.0154-.0137.0165-.0153c.0254-.167.0292-.2119.0447-.2933.0154-.0874.042-.2083.107-.5314.0309-.1517.0652-.303.0971-.4578.0332-.1542.068-.306.101-.4578l-.005-.0183zm.0039-.6206c-.1644-.1068-.453-.0729-.6471.0746-.1936.1446-.2157.3498-.0518.458.1615.1038.4512.0729.6436-.0759.1932-.1477.2174-.351.0553-.4567zm.994 2.4734c.3326 0 .6735-.101.9301-.4003.1974-.2428.288-.6041.3193-.7529.1021-.4931.0226-.7233-.0772-.8635-.1517-.2138-.4197-.2824-.6978-.2824-.1672 0-.5654.0182-.8765.334-.2234.2277-.3267.5368-.389.833-.0628.302-.135.8454.319 1.0477.14.0662.342.0844.4722.0844zm-.026-1.1095c.0768-.3734.1673-.6868.3983-.6868.181 0 .1942.2332.1137.6078-.0144.0832-.0805.3924-.1699.524-.0624.0972-.1363.1561-.2179.1561-.0243 0-.1688 0-.171-.2361-.0011-.1166.0205-.2357.0469-.365zm2.1068 1.0615l.026-.0291c.0368-.215.0429-.2655.1245-.7008.0408-.2065.1253-.66.165-.8216.075-.0384.1478-.076.2207-.076.167 0 .1467.1615.14.2259-.006.1082-.0673.4609-.1313.7639l-.0396.1955c-.0304.1446-.0635.2848-.0927.4282l.0127.0286c.3415-.02.4413-.02.7337-.0146l.0353-.0291c.0512-.336.065-.4258.161-.9146l.0458-.2247c.0916-.4397.1379-.6624.07-.844-.0749-.2035-.2509-.2526-.4092-.2526-.1049 0-.2974.0278-.4684.1208a3.0577 3.0577 0 0 0-.1826.1166l.0524-.2234-.028-.0378c-.3647.0814-.448.0923-.7846.1446l-.0258.0206c-.0408.3571-.074.6254-.219 1.3275a95.9633 95.9633 0 0 1-.17.7779l.0155.0328c.3458-.02.449-.02.7486-.0146zm2.5088.0145c.0215-.1154.149-.799.1501-.799 0 0 .1086-.5017.1152-.5199 0 0 .0342-.0522.0684-.0729h.0503c.4743 0 1.01 0 1.4298-.34.2857-.2332.481-.5775.5681-.996a1.6492 1.6492 0 0 0 .0393-.3466c0-.1603-.0292-.3189-.1137-.4428-.214-.3297-.6404-.3358-1.1326-.3383l-.2426.0025c-.63.0086-.8826.0061-.9864-.0079-.0088.0505-.0253.1404-.0253.1404s-.2256 1.1513-.2256 1.1531l-.5655 2.5632c.55-.0073.7756-.0073.8705.0042zm.4181-2.0452s.24-1.149.2388-1.1446l.0078-.059.0034-.0448.0959.0108s.4948.0468.5064.048c.1953.0832.2758.2976.2196.5774-.0513.2558-.202.4708-.3956.5746-.1594.088-.3547.0953-.556.0953h-.1301zm1.494.9905c-.0635.2975-.1364.841.3154 1.0347.144.0674.2731.0875.4043.0802.1385-.0082.2669-.0847.3858-.1948l-.0322.1359.0205.029c.325-.015.4258-.015.7778-.012l.032-.0268c.0513-.3327.0998-.6557.2334-1.2922.065-.3048.13-.6067.1968-.9103l-.0104-.0334c-.3635.0741-.4607.09-.8103.1445l-.0266.0238c-.0035.031-.0072.0607-.0106.0904-.0543-.0967-.1331-.1793-.2547-.2307-.1555-.0674-.5207.0194-.8346.334-.2206.2247-.3265.5325-.3867.8277zm.7633.0182c.0778-.3668.1672-.677.3988-.677.1465 0 .2236.1487.208.4024-.0125.0633-.026.13-.0419.2054-.0232.109-.0483.217-.0727.3252-.0249.074-.0538.1438-.0856.1903-.0596.093-.2014.1506-.283.1506-.0232 0-.166 0-.171-.232-.0011-.1154.0205-.2344.0474-.365zm3.9867-1.2109l-.0281-.0353c-.3597.0802-.4248.093-.7552.1421l-.0243.0267c-.0012.0044-.0021.011-.0038.0171l-.0012-.006c-.246.6248-.2388.49-.439.9818-.0011-.0224-.0011-.0363-.0023-.0601l-.0501-1.0663-.0315-.0353c-.3768.0802-.3857.093-.7336.1421l-.0271.0267c-.0039.0128-.0039.0268-.0061.042l.0022.0055c.0435.2446.033.19.0767.5762.0204.1895.0475.3801.0678.5673.0343.3132.0535.4674.0955.9455-.235.4268-.2907.5884-.5169.963l.0016.0037-.1593.2774c-.0182.0292-.0348.0492-.058.0578-.0253.0138-.0584.0163-.1043.0163h-.0882l-.1312.4804.45.0085c.2642-.0012.4303-.1372.5197-.32l.283-.5339h-.0045l.0298-.0376c.1904-.4511 1.6384-3.1856 1.6384-3.1856zm-4.7501 6.3088h-.191l.7067-2.573h.2344l.0745-.265.0072.2947c-.0088.1822.1214.3437.4634.317h.3956l.1361-.4954h-.1488c-.0856 0-.1253-.0238-.1203-.0748l-.0072-.2999h-.7325v.0016c-.2369.0054-.944.025-1.0873.067-.1732.049-.3558.1937-.3558.1937l.0717-.2654h-.6852l-.1428.5265-.716 2.6123h-.139l-.1363.4919h1.3647l-.0457.164h.6724l.0447-.164h.1886zm-.56-2.0502c-.1097.0334-.3139.1348-.3139.1348l.1816-.6576h.5444l-.1313.4791s-.1682.011-.2807.0437zm.0105.9394s-.171.0237-.2836.0516c-.1108.037-.3187.1536-.3187.1536l.1876-.6843h.5472zm-.305 1.1168h-.5461l.1583-.5775h.5444zm1.315-1.5959h.7872l-.113.4033h-.7977l-.1197.4408h.6979l-.5285.8191c-.037.0602-.0702.0815-.107.0984-.037.0207-.0856.045-.1418.045h-.1936l-.133.4828h.5064c.2632 0 .4187-.1318.5335-.3048l.3624-.546.0778.5544c.0165.1038.0843.1646.1302.1882.0507.028.103.076.177.0832.0794.0037.1368.0067.1749.0067h.2488l.1494-.5404h-.0981c-.0564 0-.1534-.0104-.1699-.0298-.0165-.0237-.0165-.06-.0254-.1154l-.079-.5556h-.3232l.1418-.1858h.796l.1225-.4408h-.737l.1148-.4033h.7347l.1363-.4973h-2.1906zm-6.6482 1.7082l.1837-.6728h.7551l.138-.5004h-.7558l.1153-.4141h.7386l.1369-.4846h-1.848l-.134.4846h.4198l-.112.414h-.421l-.1395.509h.4197l-.2449.8902c-.033.1178.0156.1627.0464.2175.0315.0533.0634.0886.1351.1086.074.0182.1247.0291.1936.0291h.8513l.1517-.5544-.3774.0571c-.0729 0-.2747-.0096-.2526-.0838zm.0866-3.2208l-.1914.3807c-.041.0831-.0778.1348-.111.1585-.0292.02-.0871.0285-.171.0285h-.0998l-.1335.487h.3316c.1594 0 .2819-.0643.3403-.0965.0629-.037.0794-.0159.128-.0675l.112-.1068h1.0354l.1374-.507h-.758l.1324-.277zm1.5286 3.2306c-.0177-.028-.005-.0773.022-.1799l.283-1.0311h1.0068c.1467-.0023.2526-.0042.3215-.0096.074-.0086.1545-.0377.2422-.0899.0905-.0547.1369-.1124.176-.1786.0436-.066.1137-.2107.1738-.4336l.3557-1.3049-1.0447.0067s-.3217.0522-.4633.11c-.143.0643-.3471.244-.3471.244l.0943-.3577h-.6454l-.9035 3.2986c-.032.128-.0535.221-.0585.2769-.0017.0601.069.1197.1147.1646.054.0449.134.0376.2107.0449.0806.0067.1953.0109.3536.0109h.496l.1522-.5659-.444.0462a.1138.1138 0 0 1-.096-.0516zm.4876-1.9074h1.0575l-.0673.2319c-.0094.0054-.032-.0115-.1396.0025h-.9157zm.2118-.778h1.0664l-.0767.2794s-.5026-.0054-.583.0109c-.3543.0675-.5611.2758-.5611.2758zm.8021 1.7866c-.0087.0347-.0226.0558-.042.0717-.0214.0152-.0561.0206-.108.0206h-.1506l.0089-.2824H12.7l-.0254 1.3809c-.001.0996.0078.1573.074.2035.0662.0576.2703.065.545.065h.3927l.1418-.517-.342.0207-.1136.0073c-.0155-.0073-.0304-.014-.0469-.0321-.0144-.0157-.0387-.0061-.0347-.1057l.0027-.354.3585-.0163c.1936 0 .2764-.0694.347-.1354.0674-.0633.0894-.136.1148-.2345l.0602-.3134h-.4927z"
              fill="#fefefe"
            />
          </g>
        </svg>
      );
    case BRAND_VISA:
      return (
        <svg
          className={classes}
          width="24"
          height="16"
          viewBox="0 0 24 16"
          xmlns="http://www.w3.org/2000/svg"
          {...roleInfo}
        >
          <g fillRule="nonzero" fill="none">
            <rect
              strokeOpacity=".2"
              stroke="#000"
              strokeWidth=".5"
              fill="#FFF"
              x=".25"
              y=".25"
              width="23.5"
              height="15.5"
              rx="2"
            />
            <path
              d="M2.78773262 5.91443732C2.26459089 5.62750595 1.6675389 5.39673777 1 5.23659312l.0280005-.12471102h2.73697872c.37098332.01300346.67201191.12462375.76996714.51882925l.59482061 2.83587917.18221641.85413565L6.97796639 5.1118821h1.79882257l-2.67390785 6.1656463H4.30396552l-1.5162329-5.36309108zm7.31224258 5.36963648H8.39882877l1.06401886-6.1721917H11.163901l-1.0639258 6.1721917zm6.1668069-6.02129922l-.2313529 1.3328108-.1538632-.06554092c-.3078194-.12479829-.7141522-.2495093-1.2671852-.2363313-.6716398 0-.9728545.26905813-.9798314.53174543 0 .28895604.3643786.47938251.9593659.76179318.9801104.43993579 1.4347231.97831385 1.4279323 1.68093694-.0137677 1.28044789-1.1758348 2.10786929-2.9607967 2.10786929-.7631763-.0066327-1.4982591-.1579615-1.8972429-.3284901l.2380507-1.38552277.224004.09861682c.5530331.23004776.9169465.32831555 1.5961213.32831555.4897761 0 1.0149017-.19060107 1.0215995-.60409358 0-.26923267-.2237249-.46637906-.8818761-.76842582-.6439184-.29558867-1.5048639-.78797464-1.4909101-1.67447884C11.8780532 5.84042483 13.0610509 5 14.7409877 5c.6580581 0 1.1902536.13788902 1.5257944.26277458zm2.2609703 3.83471102h1.4139786c-.0699548-.30859213-.3921-1.78601186-.3921-1.78601186l-.1188858-.5318327c-.0840015.22978594-.2308878.60409353-.2238179.59091553 0 0-.5390794 1.3723448-.6791749 1.72692903zm2.0998512-3.9856035L22 11.2839865h-1.5750977s-.1541422-.7091684-.2029803-.9258637h-2.1841317c-.0631639.1640705-.3570296.9258637-.3570296.9258637h-1.7849619l2.5268355-5.65999506c.1750729-.40057632.4833574-.51210934.889132-.51210934h1.3158373z"
              fill="#171E6C"
            />
          </g>
        </svg>
      );
    case BACK: return (
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill='none' d="M11.9987 18.6663L5.33203 11.9997L11.9987 5.33301" stroke="white" strokeWidth="2.5" strokeLinejoin="round" />
        <path fill='none' d="M26.6654 26.6667V17.3333C26.6654 15.9188 26.1035 14.5623 25.1033 13.5621C24.1031 12.5619 22.7465 12 21.332 12H5.33203" stroke="white" strokeWidth="2.5" strokeLinejoin="round" />
      </svg>
    )
    default:
      return (
        <svg
          className={classes}
          width="29"
          height="19"
          viewBox="0 0 29 19"
          xmlns="http://www.w3.org/2000/svg"
          {...roleInfo}
        >
          <g fill="none" fillRule="evenodd">
            <path
              d="M26.58 19H2.42A2.4004 2.4004 0 0 1 0 16.62V2.38A2.4 2.4 0 0 1 2.42 0h24.16A2.4004 2.4004 0 0 1 29 2.38v14.25c-.0165 1.3216-1.0984 2.3811-2.42 2.37zM10 5.83c0-.46-.35-.83-.78-.83H3.78c-.43 0-.78.37-.78.83v3.34c0 .46.35.83.78.83h5.44c.43 0 .78-.37.78-.83V5.83z"
              fill="#DADDE2"
            />
            <path
              d="M25 15h-3c-.65 0-1-.3-1-1s.35-1 1-1h3c.65 0 1 .3 1 1s-.35 1-1 1zm-6 0h-3c-.65 0-1-.3-1-1s.35-1 1-1h3c.65 0 1 .3 1 1s-.35 1-1 1zm-6 0h-3c-.65 0-1-.3-1-1s.35-1 1-1h3c.65 0 1 .3 1 1s-.35 1-1 1zm-6 0H4c-.65 0-1-.3-1-1s.35-1 1-1h3c.65 0 1 .3 1 1s-.35 1-1 1z"
              fill="#B2B6C1"
            />
          </g>
        </svg>
      );
  }
};

export default IconCard;
